<template>

  <div class="item-id">
    <div class="link" :class="url ? 'clickable' : ''" @click="clickLink">{{ id || '-' }}</div>
    <v-icon class="copy-button" v-if="nocopy !== false" small="small" title="Copy ID" @click="copyButton">mdi-content-copy</v-icon>
  </div>

</template>

<script>

export default {
  name: 'ItemID',
  props: ['id', 'url', 'nocopy'],
  methods: {
    clickLink () {
      if (this.url) {
        this.$router.push(this.url + '/' + this.id)
      }
    },
    copyButton () {
      this.$copyText(this.id)
    }
  }
}

</script>

<style lang="scss" scoped>

.item-id {
  display: grid;
  grid-template-columns: auto 40px 1fr;
  grid-column-gap: 10px;

  .copy-button {
    display: none;
  }

  &:hover .copy-button{
    display: inline;
  }
}

.link.clickable {
  display: inline;
  cursor: pointer;

  &:hover {
    color: #555;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/links/ItemID.vue